import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import styled from '@emotion/styled';
import { FlagTranslationIcon } from '@seedlang/icons';
import Confirmation from '../confirmation';
import Modal from 'components/modal';
import Button from 'components/button/button';
import { Theme } from '@seedlang/constants';
import { AppUI } from '@seedlang/state';
import { FlagButtonWrapper } from '@seedlang/hoc';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  margin: ${props => props.margin};
`;

const ModalContent = styled.div`
  padding: 20px;
  @media (max-width: 500px) {
    padding: 10px;
  }
`;

const Title = styled.div`
  font-size: 18px;
  margin-bottom: 20px;
`;

const ReasonList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`;

const ReasonButton = styled.div`
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  cursor: pointer;
  text-align: left;
  background: ${props => props.selected ? Theme.blue : '#FFF'};
  color: ${props => props.selected ? '#FFF' : '#000'};
  &:hover {
    background: ${props => props.selected ? Theme.blue : '#f5f5f5'};
  }
`;

const OtherInputWrapper = styled.div`
  margin-top: 10px;
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
`;

@observer
class FlagButton extends React.Component {
  @observable showConfirmation = false;

  constructor() {
    super();
    this.id = Math.random();
  }
  static defaultProps = {
    width: '20px',
    faIcon: 'fa-times',
  };
  onConfirm = () => {
    this.showConfirmation = false;
    this.props.onConfirm();
  }
  handleClick = () => {
    if (this.props.isFlagged) {
      this.showConfirmation = true;
    } else {
      this.props.onPress();
    }
  }

  render() {
    return (
      <Wrapper
        margin={this.props.margin}
        width={this.props.width}
      >
        {
        this.showConfirmation &&
          <Confirmation
            left={this.props.left}
            right={this.props.right}
            top={this.props.top}
            floatsRight={this.props.confirmationMessageFloatsRight}
            close={() => this.showConfirmation = false}
            onConfirm={this.onConfirm}
            message={this.props.removeFlaggingMessage}
          />
        }
        {this.props.showModal && (
          <Modal
            width={AppUI.layout.isMobile ? '90%' : '500px'}
            onCloseModal={this.props.onCancelModal}
            hideCloseIcon={false}
            title={this.props.modalTitle}
            gradient
          >
            <ModalContent>
              <Title>{this.props.questionText}</Title>
              <ReasonList>
                {this.props.reasons.map(reason => (
                  <ReasonButton
                    key={reason}
                    selected={this.props.selectedReason === reason}
                    onClick={() => this.props.onReasonSelect(reason)}
                  >
                    {reason}
                  </ReasonButton>
                ))}
              </ReasonList>
              {this.props.selectedReason === 'Other' && (
                <OtherInputWrapper>
                  <StyledInput
                    value={this.props.otherText}
                    onChange={(e) => this.props.onOtherTextChange(e.target.value)}
                    placeholder={this.props.otherInputPlaceholder}
                    maxLength={this.props.otherInputMaxLength}
                    autoFocus
                  />
                </OtherInputWrapper>
              )}
              <ButtonWrapper>
                <Button
                  onClick={this.props.onConfirmReason}
                  background={Theme.blue}
                  disabled={!this.props.canConfirm}
                >
                  {this.props.confirmButtonText}
                </Button>
              </ButtonWrapper>
            </ModalContent>
          </Modal>
        )}
        <FlagTranslationIcon
          minimumHeight='20px'
          onClick={this.handleClick}
          showTooltip
          message={this.props.isFlagged ? 'Remove Flagging' : 'Flag Incorrect Translation'}
          flagged={this.props.isFlagged}
        />
      </Wrapper>
    );
  }
}

export default FlagButtonWrapper(FlagButton);
